import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { StatisticFiltersWidgetComponent } from './statistic-filters-widget.component';
import { DropdownModule, ProgressModule, TextFieldModule } from '@mtgame/ui';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    TextFieldModule,
    ProgressModule,
  ],
  declarations: [
    StatisticFiltersWidgetComponent,
  ],
  exports: [
    StatisticFiltersWidgetComponent,
  ]
})
export class StatisticFiltersWidgetModule {}
